import { render, staticRenderFns } from "./FirstAtlasModal.vue?vue&type=template&id=08bc4681&"
import script from "./FirstAtlasModal.vue?vue&type=script&lang=js&"
export * from "./FirstAtlasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports